import { useEffect, useRef } from 'react';

const images = [
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/8e0c6ef8-3b73-4e7e-a861-1506f7fc9e6f_compressed_Captura-de-tela-2026-07-26-155212.webp',
    alt: 'Ingredientes frescos Naturalle',
    caption: 'Ingredientes frescos',
    span: 'col-span-1 row-span-2',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/1617d524-ca18-4cdd-b2b9-1d162beef725_compressed_Imagem-1-gerada-3.webp',
    alt: 'Sanduíche Naturalle cortado',
    caption: 'Sanduíche artesanal',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/a83eaf5e-6b1d-4849-a07f-91163d926bd8_compressed_Imagem-1-gerada-4.webp',
    alt: 'Produção Naturalle',
    caption: 'Produção artesanal',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/f1243fce-5231-40b4-8d68-a461124870b2_compressed_Captura-de-tela-2026-07-26-155205.webp',
    alt: 'Vegetais frescos',
    caption: 'Vegetais selecionados',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/001f83ec-e29b-4345-abc6-1e89308f7dca_compressed_Imagem-1-gerada-1.webp',
    alt: 'Cliente Naturalle',
    caption: 'Nossos clientes',
    span: 'col-span-2 row-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/46b11d92-1101-4f92-aa67-f7a4033739d8/731fe4bc-46fd-45ac-af3d-fbd7019a9c25_compressed_Captura-de-tela-2026-07-26-155149.webp',
    alt: 'Embalagem Naturalle',
    caption: 'Embalagem a vácuo',
    span: 'col-span-1 row-span-1',
  },
];

const GallerySection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="galeria" ref={sectionRef} className="relative py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-7xl">
          <div className="mb-12 text-center md:mb-16">
            <span className="reveal mb-4 inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.3em] text-secondary-500 md:text-sm">
              <span className="h-px w-8 bg-secondary-500/60" />
              Nosso Mundo
              <span className="h-px w-8 bg-secondary-500/60" />
            </span>
            <h2 className="reveal reveal-delay-1 font-display text-3xl leading-tight text-foreground-950 md:text-5xl">
              Um pouco do nosso <span className="italic text-accent-400">dia a dia</span>
            </h2>
          </div>

          {/* Masonry grid */}
          <div className="grid grid-cols-1 auto-rows-[220px] gap-3 md:grid-cols-4 md:auto-rows-[200px] md:gap-4">
            {images.map((img, index) => {
              const isWide = img.span.includes('col-span-2');
              const isTall = img.span.includes('row-span-2');
              return (
                <div
                  key={img.alt}
                  className={`reveal group relative overflow-hidden rounded-2xl border border-background-200/70 md:rounded-3xl cursor-pointer ${
                    isWide ? 'md:col-span-2' : 'md:col-span-1'
                  } ${isTall ? 'md:row-span-2' : 'md:row-span-1'}`}
                  style={{ transitionDelay: `${index * 0.1}s` }}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    title={`${img.caption} — Naturalle Sanduíches`}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                  {/* Caption */}
                  <div className="absolute bottom-0 left-0 right-0 translate-y-3 p-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 md:p-5">
                    <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-wider text-secondary-400">
                      <span className="h-px w-5 bg-secondary-500/60" />
                      {img.caption}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;